import React, { useEffect, useState, useRef } from "react";
import {
  useSearchParams,
	Link 
} from "react-router-dom";
import s from './articleWordChecker.module.css';
import {getData, postData} from '../middleware/apiMiddleware';
import {ErrorPop} from '../components/Utilities/ErrorPop'
import { useNavigate, useParams } from "react-router-dom";

import {getGeneralStorage, setGeneralStorage} from '../middleware/dataStorage';
import {GreenButton, BlueButton} from '../components/MyButton';
import Word from '../components/Word'

export default function ArticleWordChecker() {
	const navigate = useNavigate();
	
	let params = useParams();
  let wordId = (params.wordId) ? params.wordId : null;
	
	const articleRef = useRef(null);
	const itemRef = useRef(null);
	
	const [articleInput, setArticleInput] = useState("");
	const [itemId, setItemId] = useState("");
	
	const [processWords, setProcessWords] = useState([]);
	
	const [cWordBasic, setCWordBasic] = useState(null);
	const [show, setShow] = useState(false);
	
	const loadItemArticle = () => {
		
		if (itemId) {
			getData('item/loadItemArticle?id=' + itemId, navigate).then(res => {
				console.log(res.data);
				setArticleInput(res.data);
			});
			
		}
	}
	
	const fetchData = () => {
		let word = "";
		if (wordId) {
			getData('wordApi/getById?id=' + wordId, navigate).then(res => {
				let word = res.data.word;
				setCWordBasic({
					id:wordId,
					word:res.data.word
				})
				setShow(true);
			});
			
		}
	}
	
	
	const getOrCreateWord = (w, indexP) => {
		let obj = {
			"word" : w
		};
		
		postData("wordApi/getOrCreateWord", obj, navigate)
		.then((res) => {
				console.log(res.data);
				processWords[indexP] = res.data;
				setProcessWords([...processWords]);
			}
		);
	}
	
	useEffect(() => {
		fetchData();
		
	}, []);
	
	return (<div className={s['container']}>
		{
			(show) && (<Word word={cWordBasic} setWord={setCWordBasic} show={show} setShow={setShow} directOpen={true}/>)
		}
	
		{
			(!show) &&(<div>
			<div style={{fontSize:"28px", fontWeight:"bold", margin:"10px 0"}}>Article Checker</div>
				<textarea className={s.processWordTextAreaAuto} value={articleInput} rows={5}
					onChange={(e) => {
						setArticleInput(e.target.value);
					}}
					onKeyDown={(event)=>{
						if (event.keyCode === 13) {
							event.preventDefault();
							articleRef.current.click();
						}
					}}/>
			<div style={{width:"50%", margin:"auto", display:"flex"}}>
				<div style={{marginRight:"10px"}}>
					<input className={s.inputBox} type="text" value={itemId} 
						onChange={(e)=> {
							setItemId(e.target.value);
						}}
						onKeyDown={(event)=>{
							if (event.keyCode === 13) {
								event.preventDefault();
								itemRef.current.click();
							}
						}}/>
				</div>
				<div style={{marginRight:"10px"}}>
					<BlueButton myRef={itemRef} isEnabled={true} clickedAction={()=>loadItemArticle()} bText={"load item id"} />
					
				</div>
				<div style={{margin:"0 0 0 auto"}}>
					<GreenButton myRef={articleRef} isEnabled={true} clickedAction={async()=>{
						const cleanedString = articleInput.replace(/[^\w\s-]|_/g, " ");
						// Split the string into an array of words
						const wordsArray = cleanedString.split(/\s+/).filter((word) => word !== "");
						// Remove duplicates
						
						let obj = {
							"words" : [...new Set(wordsArray)]
						};
						
						let res = await postData("wordApi/getAllWordStatus", obj, navigate);
						let wordData = res.data.filter(e => (e.isChecked == 0));
						
						
						setProcessWords(wordData);
					}} bText={"Processing checking"} />
				</div>
			</div>
			<div style={{width:"50%", margin:"0 auto"}}>
				<div style={{padding:"0 5px", textAlign:"left", display:"flex", borderBottom:"1px solid black"}}>
					<div style={{width:"200px"}}>Word</div>
					<div style={{width:"100px"}}>id</div>
				</div>
			{
				processWords.map((p, indexP)=>(
					<div key={"p"+indexP} style={{padding:"0 5px", textAlign:"left", display:"flex", background:(p.isChecked) ? "#8ab9eb" : "white", color:(p.isChecked) ? "#35024d" : "black", alignItems:"center"}}>
						
						
						<input className={s.inputBox} style={{width:"180px"}} type="text" value={p.word} 
							onChange={(e)=> {
								processWords[indexP].word = e.target.value;
								processWords[indexP].isChecked = false;
								processWords[indexP].id = null;
								setProcessWords([...processWords]);
								
							}} />
						<GreenButton isEnabled={true} clickedAction={()=>getOrCreateWord(p.word, indexP)} bText={"search & create"} />
							
							{(p.id) && (<div style={{width:"100px"}}>
								<Link style={{}} to={`/articleWordChecker/${p.id}`} target="_blank">
									{p.id}
								</Link>
							</div>)}
						
					</div>))
			}
			</div>
		
		</div>)
		}
	</div>);
}
